import { FC } from 'react';
import {
  Backdrop,
  CircularProgress,
} from '@material-ui/core';

export const CircularLoader: FC = () => (
  // zindex will be 99999 because loader should come on top of every popUp or screen
  <Backdrop
    sx={{ color: '#fff', zIndex: 99999 }}
    open
  >
    <CircularProgress color="inherit" />
  </Backdrop>
);
